export default "__VITE_ASSET__CvMTnc12__"